import { Link } from 'react-router-dom';
import { IChainTrendingCoin } from '@kattana-io/common';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import placeholder from '../../../molecules/PairIcons/icons/placeholder.svg';
import NumberDisplay from '../../../molecules/NumberDisplay';

interface ITrendingCoinsProps {
  coins: Record<string, IChainTrendingCoin>;
  chain: string;
  address: string;
}

const TrendingCoins = ({ coins, chain, address }: ITrendingCoinsProps) => {
  const filteredCoins = Object.entries(coins)
    .filter(([coinAddress]) => address !== coinAddress)
    .slice(0, 8);

  return (
    <div className='mobile_seo_page__trending'>
      <div className='mobile_seo_page__trending__title'>
        <Text size={18} className='text--grey-200 text--weight-500'>
          Trending Coins
        </Text>
      </div>
      <div className='mobile_seo_page__trending__list'>
        {filteredCoins.map(([address, item], index) => (
          <Link
            key={index}
            to={`/en/token/${chain}/${address}`}
            className='mobile_seo_page__trending__list__item'
          >
            <div className='mobile_seo_page__trending__list__item__title'>
              <Image src={item.logo || placeholder} size='xl' />
              <div className='mobile_seo_page__trending__list__item__title__name'>
                <Text size={14} className='text--grey-400'>
                  {item.name}
                </Text>
                <NumberDisplay
                  value={item.price_usd}
                  startSymbol='$'
                  textProps={{
                    size: 14,
                    className: 'text--weight-600 text--grey-200',
                  }}
                />
              </div>
            </div>
            <div className='mobile_seo_page__trending__list__item__body'>
              <div
                className={`mobile_seo_page__trending__list__item__body__changes ${
                  item.price_change_percentage > 0
                    ? 'mobile_seo_page__trending__list__item__body__changes--pos'
                    : 'mobile_seo_page__trending__list__item__body__changes--neg'
                }`}
              >
                <Text size={12}>{item.price_change_percentage}%</Text>
                <div
                  className={`mobile_seo_page__trending__list__item__body__changes__icon ${
                    item.price_change_percentage > 0
                      ? 'icon-arrow-top-right'
                      : 'icon-arrow-bottom-right'
                  }`}
                />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TrendingCoins;
